/* eslint-disable */
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const swUrl = `${process.env.BASE_URL}service-worker.js`;
    navigator.serviceWorker
      .register(swUrl)
      .then((reg) => {
        // Force check for updated SW after each deploy
        reg.update().catch(() => {});
        if (reg.waiting) {
          reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
      })
      .catch((error) => {
        console.warn('StaffSync service worker registration failed:', error);
      });

    // One-time cleanup: drop any stale shell caches from older SW versions
    if (window.caches && caches.keys) {
      caches.keys().then((keys) => {
        keys
          .filter((k) => k.startsWith('staffsync-shell-') && k !== 'staffsync-shell-v3')
          .forEach((k) => caches.delete(k));
      }).catch(() => {});
    }
  });
}
